/**
 * /eric/capacity — Capacity editor (T-055, PR-49, GTM-05; T-068 server
 * cycle).
 *
 * Route config only. Component lives in eric.capacity.lazy.tsx (code-split).
 * No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/capacity')({});
